import { useEffect, useState } from 'react';

import { Button } from '@mui/material';
import axios, { AxiosError, AxiosResponse } from 'axios';
import { useSnackbar } from 'notistack';

import { AliasCollisionDialog } from 'components/PromptDialog/AliasCollisionDialog';
import strings from 'constants/index';
import { useDialogStatus } from 'hooks/common';
import { formatError } from 'utils/request.utils';

export const AliasCollision = ({ onClick }) => {
  const [error, setError] = useState(null);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const { isOpen, onShow, onHide } = useDialogStatus();

  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      async (response: AxiosResponse) => {
        if (response.config.method === 'put') {
          onHide();
          setError(null);
        }
        return response;
      },
      async (error: AxiosError) => {
        const message = formatError(error);
        if (
          error?.response?.status === 400 &&
          message.startsWith(strings.alias_collision_400_error)
        ) {
          setError(message);
          onShow();
        } else if (!axios.isCancel(error)) {
          enqueueSnackbar(message, {
            variant: 'error',
            autoHideDuration: null,
            action: key => (
              <Button color="inherit" onClick={() => closeSnackbar(key)}>
                {strings.dismiss}
              </Button>
            ),
          });
        }

        return Promise.reject(error);
      },
    );

    return () => {
      axios.interceptors.response.eject(interceptor);
      onHide();
    };
  }, [closeSnackbar, enqueueSnackbar, onHide, onShow]);

  return (
    isOpen && (
      <AliasCollisionDialog isOpen={isOpen} onHide={onHide} message={error} onClick={onClick} />
    )
  );
};
